import axios from '@/plugins/axios';

const getAll = (params) => {
  return axios.get('/location', { params });
};

const getOne = (id) => {
  return axios.get('/location/' + id);
};

const getCities = (params) => {
  return axios.get('/location/cities', { params });
};

const getLabels = (params) => {
  return axios.get('/location/labels', { params });
};

const getCategories = (params) => {
  return axios.get('/location/categories', { params });
};

const getLogs = (params) => {
  return axios.get('/log', { params });
};

const getStates = (params) => {
  return axios.get('/location/states', { params });
};

const getAddresses = (params) => {
  return axios.get('/location/addresses', { params });
};

const getTasks = (id, params) => {
  return axios.get(`/location/${id}/tasks`, { params });
};

const create = (data) => {
  return axios.post(`/location`, data);
}

const update = (id, data) => {
  return axios.put('/location/' + id, data);
};

const getFoodMenu = (id) => {
  return axios.get(`/location/${id}/foodmenu`);
};

const updateFoodMenu = (id, data) => {
  return axios.put(`/location/${id}/foodmenu`, data);
};

const sendBulk = (params) => {
  return axios.put(`/location/bulk`, params.payload);
};

const exportLocations = (data) => {
  return axios.get(`/location/download`, { responseType: 'blob', params:data })
}

const getBulkVariables = () => {
  return axios.get(`/location/variables`)
}

const getBulkAttributes = (params) => {
  return axios.get(`/location/attributes-bulk`, { params })
}

const geocodeSearch = (address, key) => {
  return fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${key}`)
}

const createExportLocations = (data) => {
  return axios.post(`/location/export`, data)
}

const sendVerification = (id,data) => {
  return axios.post(`/location/${id}/verify`, data);
};

const getVerification = (id) => {
  return axios.get(`/location/${id}/verification-options`)
};

const confirmVerification = (id,verificationId,data) =>{
  return axios.post(`/location/${id}/complete-verification/${verificationId}`,data)
};

const uploadLocationXlsFile = (data) => {
  return axios.post(`/account/import-file`,data)
};

const getMoreHourTypes = () => {
  return axios.get(`/location/more-hour-types`)
};

const transferLocations = (data) => {
  return axios.post(`/location/transferLocations`, data)
};

export default {
  getAll,
  getCities,
  getStates,
  getAddresses,
  getOne,
  getTasks,
  create,
  update,
  getFoodMenu,
  updateFoodMenu,
  getLogs,
  sendBulk,
  exportLocations,
  getBulkVariables,
  getBulkAttributes,
  geocodeSearch,
  createExportLocations,
  getLabels,
  getCategories,
  sendVerification,
  getVerification,
  confirmVerification,
  uploadLocationXlsFile,
  getMoreHourTypes,
  transferLocations
};
